export const unitTabs = [
  { id: "selling_units", label: "Selling Units" },
  { id: "shipping_units", label: "Shipping Units" },
  { id: "vendor-units", label: "Vendor Units" },
];
